// src/components/Courses.js
import React from 'react';
import './Courses.css';

const coursesData = [
  {
    title: "100 - Hour Yoga TTC",
    desc: "Comprehensive training to build a strong foundation in yoga teaching.",
    img: "/Media/YTTC/100.webp",
    duration: "15 Days",
    start: "3rd To 17th Every Month",
    language: "English & Hindi",
    fees: "$899",
    link: "http://wa.me/919999345631"
  },
  {
    title: "200 - Hour Yoga TTC",
    desc: "Deepen your yoga practice with advanced techniques and philosophy.",
    img: "/Media/YTTC/200.webp",
    duration: "28 Days",
    start: "3rd To 30th Every Month",
    language: "English & Hindi",
    fees: "$1599",
    link: "http://wa.me/919999345631"
  },
  {
    title: "300 - Hour Yoga TTC",
    desc: "Master-level training for dedicated yoga teachers and practitioners.",
    img: "/Media/YTTC/300.webp",
    duration: "28 Days",
    start: "3rd To 30th Every Month",
    language: "English & Hindi",
    fees: "$1799",
    link: "http://wa.me/919999345631"
  }
];

const Courses = () => {
  return (
    <section className="courses-section" id="courses">
      <h2 className="courses-main-heading">Yoga Teacher Training Courses</h2>

      <div className="courses-grid">
        {coursesData.map((course, idx) => (
          <div className="course-card" key={idx}>
            <img src={course.img} alt={course.title} className="course-image" />
            <h3 className="course-title">{course.title}</h3>
            <p className="course-desc">{course.desc}</p>

            <div className="course-details">
              <p className="detail-row">
                <img className="detail-icon" src="/Media/YTTC/time.png" alt="Duration" />
                Duration: {course.duration}
              </p>
              <p className="detail-row">
                <img className="detail-icon" src="/Media/YTTC/date.png" alt="Start Dates" />
                Start Dates: {course.start}
              </p>
              <p className="detail-row">
                <img className="detail-icon" src="/Media/YTTC/language.png" alt="Language" />
                Language: {course.language}
              </p>
              <p className="detail-row">
                <img className="detail-icon" src="/Media/YTTC/fees.png" alt="Fees" />
                Fees: {course.fees}
              </p>
            </div>

            <a
              href={course.link}
              target="_blank"
              rel="noopener noreferrer"
              className="enroll-btn"
            >
              Contact us
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Courses;
